import { Button, Checkbox, Divider, FormControlLabel, Grid, Radio, Stack, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import DropDownOA from '../../../../common/dropDownOA'
import LineinputV2 from '../../../../common/lineinputV2'
import Modal from '../../../../common/modal'
import { Item } from '../../../../common/snippets'
import { consTypeMOPData } from '../../GSConstants'
import { useState } from 'react'
import { connect } from 'react-redux'
import { updateAlertError, updateModal } from '../../../../../store/common/common_action';
import { useEffect } from 'react'
import { focusElemnt, navigation1, navigation3 } from '../../../../common/helper'
import { bookingCreateNewConsType, getBookingConsType } from '../../../../../store/generalSetting/GSAction'
import Lineinput from '../../../../common/lineinput'
import ReplayIcon from '@mui/icons-material/Replay';
import { useTranslation } from '../../../../../i18n/I18nProvider'

const ConsignmentTypeModal = (props) => {
    const { data, updateModal, updateAlertError, bookingCreateNewConsType, getBookingConsType } = props
    const { isUpdate, propData, editData } = props
    const { common } = data
    const { loginData, methodOfPckgTypes } = { ...common }
    const { translations, language } = useTranslation()
    const gs = translations?.generalSettings || {}
    const tr = (key, fallback) => gs?.[key] || fallback
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    const billingUnitData = [
        { value: tr('gsPerKg', 'Per KG'), id: 1 },
        { value: tr('gsPerUnit', 'Per Unit'), id: 2 },
        // { value: 'Per KG - KM', id: 3 },
    ]
    const unitData = [{ value: tr('gsPerUnit', 'Per Unit'), id: 1 }, { value: tr('inclAllUnit', 'Incl. All Unit'), id: 2 }]
    const appPaymentTypeData = [{ value: tr('onAccount', 'On Account'), id: 1 }]
    const weightTypeData = [{ value: tr('actual', 'Actual'), id: 0 }, { value: tr('volume', 'Volume'), id: 1 }]
    const mopEditableOpts = consTypeMOPData.map((item) => ({ ...item, value: tr(item.translationKey, item.value) }))

    const [selectedBU, setSelectedBU] = useState("")
    const [consType, setConsType] = useState("")
    const [consignmentId, setConsignmentId] = useState("NA")
    const [ratePerKg, setRatePerKg] = useState("")
    const [selectedMOPEditable, setSelectedMOPEditable] = useState("")
    const [selectedGST, setSelectedGST] = useState("")
    const [selectedMOP, setSelectedMop] = useState("")
    const [selectedWT, setSelectedWT] = useState("")
    const [selectedUnit, setSelectedUnit] = useState(unitData?.[0])
    const [selectedUnitInp, setSelectedUnitInp] = useState("")
    const [selActiveConsType, setSelActiveConsType] = useState(false)
    const [selMinimumWC, setSelMinimumWC] = useState(true)
    const [perkgkmFlag, setPerKgKM] = useState(true)
    const [newConsCreated, setNewConsCreated] = useState(false)
    const [mhWeightChrg, setMHWeightChrg] = useState(false)
    const [paidonly,setPaidOnly] = useState(false)
    const [disallowMultipleConsignment,setdmc] = useState(false)
    const [selectedRadio, setSelectedRadio] = useState({IsKgKm:0,IsCityPairRate:0,IsStandaradRate:0})

    useEffect(() => {
        focusElemnt("consignmentType")
    }, [])
    useEffect(() => {
        setSelectedBU((prev) => (prev?.id != null ? billingUnitData.find((item) => item.id === prev.id) || prev : prev))
        setSelectedUnit((prev) => (prev?.id != null ? unitData.find((item) => item.id === prev.id) || unitData[0] : prev))
        setSelectedWT((prev) => (prev?.id != null ? weightTypeData.find((item) => item.id === prev.id) || prev : prev))
        setSelectedMOPEditable((prev) => (prev?.id != null ? mopEditableOpts.find((item) => item.id === prev.id) || prev : prev))
        setSelectedGST((prev) => (prev?.id != null ? mopEditableOpts.find((item) => item.id === prev.id) || prev : prev))
    }, [translations])
    useEffect(() => {
        if (isUpdate) {
            setConsType(editData?.SubType)
            setConsignmentId(editData?.ConsignmentSubTypeID)
            setSelectedMop(methodOfPckgTypes?.filter((val) => val.MOPID === editData.DefaultMOPId)?.[0] || "")
            setSelectedMOPEditable(mopEditableOpts.filter((val) => val.id === editData.IsMOPEditable)?.[0] || "")
            setSelectedGST(mopEditableOpts.filter((val) => val.id === editData.HasStax)?.[0] || "")
            setSelectedBU(billingUnitData?.filter((val) => val.id === editData.BillingUnit)?.[0] || "")
            setRatePerKg(editData?.Rate || "")
            setSelectedWT(weightTypeData?.filter((val) => val.id === editData.IsVolumetricWeight)?.[0] || weightTypeData?.filter((val) => val.value === editData.WeightCharged)?.[0] || "")
            if (editData.MinWeightPerUnit !== 0) {
                setSelectedUnit(unitData[0])
                setSelectedUnitInp(editData.MinWeightPerUnit)
            } else if (editData.MinWeightAllUnits !== 0) {
                setSelectedUnit(unitData[1])
                setSelectedUnitInp(editData.MinWeightAllUnits)
            } else {
                setSelectedUnit(unitData[0])
                setSelectedUnitInp("")
            }
            if (editData?.IsActive) {
                setSelActiveConsType(true)
            } else {
                setSelActiveConsType(false)
            }
            if (editData.MinWeightPerUnit === 0 && editData.MinWeightAllUnits === 0) {
                setSelMinimumWC(false)
            }
            if(editData.IsKgKm === 0){
                setPerKgKM(false)
            }
            if(editData?.IsMinWeightCharge==1){
                setMHWeightChrg(true)
            } else {
                setMHWeightChrg(false)
            }
            setSelectedRadio((prev)=>({
                ...prev,
                IsKgKm:editData?.IsKgKm,
                IsCityPairRate:editData?.IsCityPairRate,
                IsStandaradRate:editData?.IsStandardRate
            }))
            setPaidOnly(editData.PaidOnly === 1)
            setdmc(editData.DisallowMultipleCons === 1)
        }
    }, [])
    const handleChange = (e, key) => {
        const regex = new RegExp('^[0-9\""]*$');
        if (regex.test(e.target.value)) {
            if (key === "rate") {
                setRatePerKg(Number(e.target.value))
            } else {
                setSelectedUnitInp(Number(e.target.value))
            }
        }
    }

    const handleCreate = () => {
        const obj = {
            ConsignmentSubTypeID: consignmentId === "NA" ? 0 : consignmentId,
            CompanyID: loginData?.intCompanyID,
            ConsignmentTypeID: 0,
            SubType: consType,
            BillingUnit: selectedBU?.id,
            MeasurementUnit: 0,
            MinWeightPerUnit: selMinimumWC ? selectedUnit?.id == 1 ? selectedUnitInp : 0 : 0,
            MultiplesOfWeight: 0,
            Remarks: "",
            IsActive: selActiveConsType ? 1 : 0,
            IsDeleted: 0,
            Rate: ratePerKg || 0,
            MOPDefault: selectedMOP?.MOPID || 0,
            IsMOPEditable: selectedMOPEditable?.id || 0,
            MinWeightAllUnit: selMinimumWC ? selectedUnit?.id == 2 ? selectedUnitInp : 0 : 0,
            IsVolumetricWeight: selectedWT?.id || 0,
            HasTax: selectedGST?.id || 0,
            IsKgKm: perkgkmFlag ? 1 : 0,
            UserID: loginData?.intUserID,
            IsMinWeightCharge: selectedWT !== "" && selectedWT?.id == 1 && selectedBU?.id == 1 ? mhWeightChrg ? 1 : 0 : 0,
            IsKgKm: selectedRadio?.IsKgKm,
            IsCityPairRate:selectedRadio?.IsCityPairRate,
            IsStandaradRate:selectedRadio?.IsStandaradRate,
            DisallowMultipleCons: disallowMultipleConsignment ? 1 : 0,
            PaidOnly: paidonly ? 1 : 0,
        }
        bookingCreateNewConsType(obj).then((res) => {
            if (res?.status == 'Success') {
                setNewConsCreated(true)
            } else {
                updateModal(false, "CreateNewConsignmentType");
                updateAlertError({ show: true, msg: res.Message, nextId: 'GSBConsignment_Type' })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }

    const modalClose = () => {
        const { selConsType, selStatus } = propData
        const obj = {
            intConsignmentSubTypeID: selConsType?.ConsignmentSubTypeID,
            intCompanyID: loginData?.intCompanyID,
            intConsignmentTypeID: 0,
            strSubType: selConsType?.ConsignmentSubTypeID === 0 ? "" : selConsType?.SubType || "",
            intIsActive: selStatus?.id,
            intIsDeleted: 0
        }
        getBookingConsType(obj)
        updateModal(false, "CreateNewConsignmentType")
        setNewConsCreated(false)
        focusElemnt("GSBConsignment_Type")
    }

    const onWeightSelect = (val) => {
        if (isUpdate) {
            if (editData.MinWeightPerUnit !== 0 && val.id == 0) {
                setSelectedUnitInp(editData.MinWeightPerUnit)
            } else if (editData.MinWeightAllUnits !== 0 && val.id == 0) {
                setSelectedUnitInp(editData.MinWeightAllUnits)
            } else {
                setSelectedUnitInp(0)
            }
        } else if (val.id == 1) {
            setSelectedUnitInp(0)
        }
        setSelectedWT(val)
    }
    const selectBillingUnit = (value) => {
        if (value?.id === 2) {
            setSelectedWT(weightTypeData?.[0])
            setSelectedUnitInp(0)
            setSelMinimumWC(false)
        }
        setSelectedBU(value)
    }
    const handleRadioChange = (key) => (event) => {
        setSelectedRadio((prevState) => ({
            IsKgKm: key === 'IsKgKm' ? 1 : 0,
            IsCityPairRate: key === 'IsCityPairRate' ? 1 : 0,
            IsStandaradRate: key === 'IsStandaradRate' ? 1 : 0,
        }));
    };
    const handleReset = () => {
        setSelectedRadio({
            IsKgKm: 0,
            IsCityPairRate: 0,
            IsStandaradRate: 0
        })
    }
    return (
        <>
            <Modal headTxt={isUpdate ? tr('editConsignmentType', 'Edit Consignment Type') : tr('createNewConsignmentType', 'Create New Consignment Type')} modalStyle={modalStyle} modalClass={'booking-popup'} width={newConsCreated ? "25%" : '80%'} closeId={"closeButton"} updateModal={updateModal} sx={{ marginTop: '20px' }}>
                {newConsCreated ?
                    <>
                        <Stack>
                            <Box style={{ margin: '10px', fontSize: '17px' }}>
                                {
                                    isUpdate ?
                                        <div> {tr('cnsTypeUpdated', 'Consignment Type Updated !')}</div>
                                        :
                                        <div> {tr('cnsTypeCreated', 'Consignment Type Created!')}</div>
                                }
                            </Box>
                        </Stack>
                        <Stack>
                            <div className="modal-btn-grp" style={{ marginRight: '10px' }}>
                                <button
                                    autoFocus
                                    style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px' }}
                                    onClick={() => modalClose()}
                                >
                                    {tr('gsOk', 'Ok')}
                                </button>
                            </div>
                        </Stack>
                    </>
                    :
                    <>
                        <Stack className="GSConsTypeModal">
                            <Grid container >
                                <Grid item xs={6} md={2.4}>
                                    <Box sx={{ paddingX: "6px" }} className={'input--wrapper'} >
                                        <LineinputV2
                                            id={"consignmentType"}
                                            label={tr('consignmentType', 'Consignment Type')}
                                            value={consType}
                                            type="text"
                                            name="Consignment Type"
                                            sx={{ margin: '8px', width: '100%' }}
                                            onKeyDown={(e) => navigation1(e, "CTMop", "CUButton")}
                                            onBlur={(e) => setConsType(e.target.value)}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={6} md={2.4}>
                                    <Box sx={{ paddingX: "6px" }} className={'input--wrapper'} >
                                        <LineinputV2
                                            // id={iid.additionalChrg}
                                            label={tr('consignmentId', 'Consignment ID ')}
                                            type="text"
                                            name="Consignment ID "
                                            disabled={true}
                                            value={consignmentId}
                                            sx={{ margin: '8px', width: '100%' }}

                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={6} md={2.4}>
                                    <Box sx={{ paddingX: "6px" }}>
                                        <DropDownOA
                                            id="CTMop"
                                            defaultvalue={selectedMOP?.MOPName || ""}
                                            data={methodOfPckgTypes || []}
                                            onSelResetVal={true}
                                            width="100%"
                                            searchPlaceholder={tr('searchSelectMop', 'Search Select MOP')}
                                            label={tr('selectMop', 'Select MOP')}
                                            dataKey={`MOPName`}
                                            idKey={`MOPID`}
                                            nextId={"CTMopEdit"}
                                            prevId={"consignmentType"}
                                            onSelect={(value) => setSelectedMop(value)}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={6} md={2.4}>
                                    <Box sx={{ paddingX: "6px" }}>
                                        <DropDownOA
                                            id="CTMopEdit"
                                            defaultvalue={selectedMOPEditable?.value || ""}
                                            data={mopEditableOpts}
                                            width="100%"
                                            searchPlaceholder={tr('searchMopEditable', 'Search MOP Editable')}
                                            label={tr('mopEditable', 'MOP Editable')}
                                            dataKey={`value`}
                                            idKey={`id`}
                                            nextId={"CTGST"}
                                            prevId={"CTMop"}
                                            onSelect={(value) => setSelectedMOPEditable(value)}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={6} md={2.4}>
                                    <Box sx={{ paddingX: "6px" }}>
                                        <DropDownOA
                                            id="CTGST"
                                            data={mopEditableOpts}
                                            defaultvalue={selectedGST?.value || ''}
                                            width="100%"
                                            searchPlaceholder={tr('searchGstApplicable', 'Search GST Applicable')}
                                            label={tr('gstApplicable', 'GST Applicable')}
                                            dataKey={`value`}
                                            idKey={`id`}
                                            nextId={"CTBillingUnit"}
                                            prevId={"CTMopEdit"}
                                            onSelect={(value) => setSelectedGST(value)}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Stack>
                        <Stack className="GSConsTypeModal">
                            <Grid container >
                                <Grid item xs={6} md={2.4}>
                                    <Box sx={{ paddingX: "6px" }}>
                                        <DropDownOA
                                            key={`CTBillingUnit-${language}-${selectedBU?.value}`}
                                            id="CTBillingUnit"
                                            defaultvalue={selectedBU?.value || ''}
                                            data={billingUnitData}
                                            width="100%"
                                            searchPlaceholder={tr('searchBillingUnit', 'Search Billing Unit')}
                                            label={tr('billingUnit', 'Billing Unit')}
                                            dataKey={`value`}
                                            idKey={`id`}
                                            onSelect={(value) => selectBillingUnit(value)}
                                            nextId={"ratePerKg"}
                                            prevId={"CTGST"}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={6} md={2.4}>
                                    <Box sx={{ paddingX: "6px" }} className={'input--wrapper'} >
                                        <Lineinput
                                            id={"ratePerKg"}
                                            label={tr('defaultRatePerKgUnit', `Default Rate Per ${selectedBU?.id == 1 ? "KG" : "Unit"}`)}
                                            type="text"
                                            name="Default Rate Per KG"
                                            value={ratePerKg}
                                            sx={{ margin: '8px', width: '100%' }}
                                            onChange={(e) => handleChange(e, "rate")}
                                            onKeyDown={(e) => navigation1(e, selectedBU?.id == 2 ? "AConsignmentType" : "CTWeightType", "CTBillingUnit")}
                                        />
                                    </Box>                                    
                                </Grid>
                                {
                                    selectedBU?.id === 2 ? "" :
                                        <>
                                            <Grid item xs={6} md={2.4}>
                                                <Box sx={{ paddingX: "6px" }}>
                                                    <DropDownOA
                                                        id="CTWeightType"
                                                        data={weightTypeData || []}
                                                        defaultvalue={selectedWT?.value || ""}
                                                        width="100%"
                                                        searchPlaceholder={tr('searchWeightType', 'Search Weight Type')}
                                                        label={tr('weightType', 'Weight Type')}
                                                        dataKey={`value`}
                                                        idKey={`id`}
                                                        onSelect={(value) => onWeightSelect(value)}
                                                        nextId={selectedWT.id == 1 ? "minimamWCAV" : "per-kg-km"}
                                                        prevId={"ratePerKg"}
                                                    />
                                                </Box>
                                            </Grid>
                                            {
                                                selectedWT?.id == 1 ?
                                                    <>
                                                        <Grid item xs={6} md={4}>
                                                            <Box sx={{ paddingX: "6px" }}>
                                                                <FormControlLabel
                                                                    id="minimamWCAV"
                                                                    value="end"
                                                                    checked={mhWeightChrg}
                                                                    onChange={(e) => setMHWeightChrg(!mhWeightChrg)}
                                                                    control={<Checkbox />}
                                                                    label={
                                                                        <Typography variant='h6' sx={{ fontWeight: '600', lineHeight: '18px' }}>
                                                                            {tr('minWeightChargeHigher', 'Minimum Weight Charge : Higher of Acutal or Volume')}
                                                                        </Typography>
                                                                    }
                                                                    labelPlacement="end"
                                                                    onKeyDown={(e) => navigation1(e, "AConsignmentType", "CTWeightType")}
                                                                />
                                                            </Box>
                                                        </Grid>
                                                    </>
                                                    :
                                                    <>
                                                        <Grid item xs={6} md={2.4}>
                                                            <Box sx={{ paddingX: "6px" }}>
                                                               <FormControlLabel
                                                                    id="minimamWC"
                                                                    value="end"
                                                                    checked={selMinimumWC}
                                                                    onChange={(e) => setSelMinimumWC(!selMinimumWC)}
                                                                    control={<Checkbox />}
                                                                    label={
                                                                        <Typography variant='h6' sx={{ fontWeight: '600', lineHeight: '18px' }}>
                                                                            {tr('minWeightCharge', 'Minimum Weight Charge')}
                                                                        </Typography>
                                                                    }
                                                                    labelPlacement="end"
                                                                    onKeyDown={(e) => navigation1(e, selMinimumWC ? "perUnit" : "AConsignmentType", "CTWeightType")}
                                                                />
                                                            </Box>
                                                        </Grid>
                                                        {selMinimumWC ? <><Grid item xs={6} md={1.5} >
                                                            <Box sx={{ paddingX: "6px" }}>
                                                                <DropDownOA
                                                                    key={`perUnit-${language}-${selectedUnit?.value}`}
                                                                    data={unitData || []}
                                                                    defaultvalue={selectedUnit?.value || ""}
                                                                    id="perUnit"
                                                                    width="100%"
                                                                    listWidth={"170px"}
                                                                    searchPlaceholder={tr('searchPerUnit', 'Search Per Unit')}
                                                                    label={tr('weightChgShort', 'Weight chg.')}
                                                                    dataKey={`value`}
                                                                    idKey={`id`}
                                                                    nextId={"perUnitInpu"}
                                                                    prevId={"minimamWC"}
                                                                    onSelect={(value) => setSelectedUnit(value)}
                                                                />
                                                            </Box>
                                                        </Grid>
                                                            <Grid item xs={6} md={0.9} >
                                                                <Box sx={{ paddingX: "6px" }} className={'input--wrapper'} >
                                                                    <Lineinput
                                                                        id={"perUnitInpu"}
                                                                        label={tr('inKgs', 'In KGs')}
                                                                        type="text"
                                                                        name=""
                                                                        value={selectedUnitInp}
                                                                        sx={{ margin: '8px', width: '100%' }}
                                                                        onChange={(e) => handleChange(e, "perUnit")}
                                                                        onKeyDown={(e) => navigation1(e, "AConsignmentType", "perUnit")}
                                                                    />
                                                                </Box>
                                                            </Grid>
                                                            </> : ""}
                                                    </>
                                            }
                                        </>
                                }
                                <FormControlLabel
                                    id="per unit km"
                                    value="end"
                                    style={{marginLeft:'-5px',display:'none'}}
                                    checked={selMinimumWC}
                                    onChange={(e) => {}}
                                    disabled
                                    control={<Checkbox />}
                                    label={
                                        <Typography variant='h6' sx={{ fontWeight: '600', lineHeight: '18px' }}>
                                            Per Unit - KM
                                        </Typography>
                                    }
                                    labelPlacement="end"
                                    onKeyDown={(e) => navigation1(e, selMinimumWC?"perUnit":"AConsignmentType", "CTWeightType")}
                                />
                            </Grid>
                        </Stack>
                        <Stack className="GSConsTypeModal">
                            <Grid container >
                                <Grid item xs={6} md={2.4}>
                                    <Box sx={{ paddingX: '6px' }}>
                                        <FormControlLabel
                                        id="minimamWCAV"
                                        value="end"
                                        checked={paidonly}
                                        onChange={(e) => setPaidOnly((a)=>!a)}
                                        control={<Checkbox />}
                                        label={
                                            <Typography variant="h6" sx={{ fontWeight: '600', lineHeight: '18px' }}>
                                            {tr('paidOnly', 'Paid Only')}
                                            </Typography>
                                        }
                                        labelPlacement="end"
                                        onKeyDown={(e) => navigation1(e, 'AConsignmentType', 'CTWeightType')}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={6} md={2.4}>
                                    <Box sx={{ paddingX: '6px' }}>
                                        <FormControlLabel
                                        id="minimamWCAV"
                                        value="end"
                                        checked={disallowMultipleConsignment}
                                        onChange={(e) => setdmc((a)=>!a)}
                                        control={<Checkbox />}
                                        label={
                                            <Typography variant="h6" sx={{ fontWeight: '600', lineHeight: '18px' }}>
                                            {tr('disallowMultipleCns', 'Disallow Multiple Consignment')}
                                            </Typography>
                                        }
                                        labelPlacement="end"
                                        onKeyDown={(e) => navigation1(e, 'AConsignmentType', 'CTWeightType')}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Stack>
                        <Divider />
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: "12px 14px" }}>
                            {/* <Box style={{ display: 'flex', backgroundColor: 'lightblue' }}> */}
                            <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: '#eef6ff', border: '1px solid #0086ff', borderRadius: '10px', padding: '0px 15px 0px 15px' }}>
                                {/* <Item> */}
                                <Typography variant='h6' sx={{ fontWeight: '600', lineHeight: '2.6', fontSize: '15px', color: '#444', marginRight: '10px' }}> {tr('selectRateMatrix', 'Select Rate Matrix')}</Typography>
                                {/* </Item>
                                <Item> */}
                                <FormControlLabel id="AConsignmentType"
                                    control={<Radio checked={selectedRadio?.IsKgKm===1} />}
                                    label={
                                        <Typography variant='h6' sx={{ fontWeight: '600' }}>
                                            {tr('kgKmRates', 'KG-KM Rates')}
                                        </Typography>
                                    }
                                    onChange={handleRadioChange('IsKgKm')}
                                    onKeyDown={(e) => navigation1(e, "CUButton", selectedBU?.id == 2 ? "ratePerKg" : selectedWT.id == 1 ? "minimamWCAV" : selMinimumWC ? "perUnitInpu" : "minimamWC")}
                                />
                                {/* </Item>
                                <Item> */}
                                <FormControlLabel id="AConsignmentType"
                                    control={<Radio checked={selectedRadio?.IsCityPairRate===1} />}
                                    label={
                                        <Typography variant='h6' sx={{ fontWeight: '600' }}>
                                            {tr('cityPairWiseRates', 'City Pair Wise Rates')}
                                        </Typography>
                                    }
                                    onChange={handleRadioChange('IsCityPairRate')} 
                                    onKeyDown={(e) => navigation1(e, "CUButton", selectedBU?.id == 2 ? "ratePerKg" : selectedWT.id == 1 ? "minimamWCAV" : selMinimumWC ? "perUnitInpu" : "minimamWC")}
                                />
                                {/* </Item>
                                <Item> */}
                                <FormControlLabel id="AConsignmentType"
                                    control={<Radio checked={selectedRadio?.IsStandaradRate===1} />}
                                    label={
                                        <Typography variant='h6' sx={{ fontWeight: '600' }}>
                                            {tr('standardKgUnitKmRates', 'Standard (KG/Unit-KM) Rates')}
                                        </Typography>
                                    }
                                    onChange={handleRadioChange('IsStandaradRate')}
                                    onKeyDown={(e) => navigation1(e, "CUButton", selectedBU?.id == 2 ? "ratePerKg" : selectedWT.id == 1 ? "minimamWCAV" : selMinimumWC ? "perUnitInpu" : "minimamWC")}
                                />
                                <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={()=>{handleReset()}}>
                                    <ReplayIcon sx={{ color: '#0086ff', marginRight: '8px', fontSize: '24px' }} />
                                    <Typography variant='h6' sx={{ fontWeight: '600', lineHeight: '2.6', color: '#0086ff', fontSize: '15px' }}>
                                        {tr('reset', 'RESET')}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box sx={{ display: 'flex' }}>
                                <Item>
                                    <FormControlLabel id="AConsignmentType" control={<Checkbox checked={selActiveConsType} />}
                                        label={
                                            <Typography variant='h6' sx={{ fontWeight: '600' }}>
                                                {tr('gsActive', 'Active')}
                                            </Typography>
                                        }
                                        onChange={(e) => setSelActiveConsType(!selActiveConsType)}
                                        onKeyDown={(e) => navigation1(e, "CUButton", selectedBU?.id == 2 ? "ratePerKg" : selectedWT.id == 1 ? "minimamWCAV" : selMinimumWC ? "perUnitInpu" : "minimamWC")}
                                    />
                                </Item>
                                <Item className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "consignmentType", "AConsignmentType", () => { })}>
                                    <Button variant="contained" id="CUButton" style={{ ...sx.fullHeight, ...sx.novp, padding: "5px 20px" }} className="btn btn-primary" onClick={() => handleCreate()}
                                        disabled={consType == "" || selectedMOPEditable === "" || selectedGST === "" || selectedBU === "" || ratePerKg === "" || (selectedBU?.id == 1 && (selectedWT === "" || (selectedWT?.id == 0 && selectedUnitInp === "" && selMinimumWC)))}
                                    >
                                        {isUpdate ? tr('gsUpdate', 'UPDATE') : tr('create', 'CREATE')}
                                    </Button>
                                </Item>
                            </Box>
                        </Box>
                    </>
                }
            </Modal>
        </>
    )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
    updateModal, updateAlertError, bookingCreateNewConsType, getBookingConsType
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsignmentTypeModal)